import pushGA4 from "../utils/pushGA4";
import pushYM from "../utils/pushYM";
var PromotionName;
(function (PromotionName) {
    PromotionName["loadBanner"] = "load_banner";
    PromotionName["showBanner"] = "show_banner";
    PromotionName["clickBanner"] = "click_banner";
    PromotionName["closeBanner"] = "close_banner";
})(PromotionName || (PromotionName = {}));
export var ItemVariant;
(function (ItemVariant) {
    ItemVariant["small"] = "small";
    ItemVariant["card"] = "card";
    ItemVariant["install_app"] = "install_app";
    ItemVariant["promo"] = "promo";
})(ItemVariant || (ItemVariant = {}));
export var analyticsBannerLoad = function (items) {
    pushGA4('view_promotion', 'portal', 'main', {
        step: 'banner',
        promotion_name: PromotionName.loadBanner,
        items: items
    });
    pushYM({
        goalParams: {
            event_name: 'view_promotion',
            application: 'portal',
            flow: 'main',
            step: 'banner',
            promotion_name: PromotionName.loadBanner,
            items: items,
        },
    });
};
export var analyticsBannerShow = function (items) {
    pushGA4('view_promotion', 'portal', 'main', {
        step: 'banner',
        promotion_name: PromotionName.showBanner,
        items: items,
    });
    pushYM({
        goalParams: {
            event_name: 'view_promotion',
            application: 'portal',
            flow: 'main',
            step: 'banner',
            promotion_name: PromotionName.showBanner,
            items: items,
        },
    });
};
export var analyticsBannerClick = function (items) {
    pushGA4('select_promotion', 'portal', 'main', {
        step: 'banner',
        items: items,
        promotion_name: PromotionName.clickBanner,
    });
    pushYM({
        goalParams: {
            event_name: 'select_promotion',
            application: 'portal',
            flow: 'main',
            step: 'banner',
            items: items,
            promotion_name: PromotionName.clickBanner,
        },
    });
};
export var analyticsBannerClose = function (items) {
    pushGA4('select_promotion', 'portal', 'main', {
        step: 'banner',
        items: items,
        promotion_name: PromotionName.closeBanner,
    });
    pushYM({
        goalParams: {
            event_name: 'select_promotion',
            application: 'portal',
            flow: 'main',
            step: 'banner',
            items: items,
            promotion_name: PromotionName.closeBanner,
        },
    });
};
